import React, { useEffect, useState } from "react";
import axios from "axios";
import ActionItem from "../components/ActionItem";
import Leaderboard from "../components/Leaderboard";
import Header from "../components/Header";
import LayoutContent from "../components/LayoutContent";
import DecorativeLines5 from "../components/DecorativeLines5";
import { getIsScoringEnabled, getStoredCategories } from "../utils/storage";

const EndPage = ({
    teamAction,
    deleteTeamAction,
    updateTeamAction,
    clearSession,
}) => {
    const isScoringEnabled = getIsScoringEnabled();
    const [categoryScores, setCategoryScores] = useState(null);
    const [isLoadingScores, setIsLoadingScores] = useState(true);

    const getCategoriesRelatedToSelectedSectors = (allCategories = []) => {
        const categories = Array.isArray(allCategories) ? allCategories : [];
        const selectedSectors = (getStoredCategories([]) || [])
            .map(Number)
            .filter((id) => !Number.isNaN(id));

        const toCategoryIds = (items) =>
            items
                .map((category) => Number(category.category_id))
                .filter((id) => !Number.isNaN(id));

        if (!selectedSectors.length) {
            return toCategoryIds(categories);
        }

        const hasSectorLinks = categories.some((category) =>
            Array.isArray(category.sector_ids),
        );

        if (!hasSectorLinks) {
            return toCategoryIds(categories);
        }

        return toCategoryIds(
            categories.filter((category) => {
                const sectorIds = (category.sector_ids || []).map(Number);
                return sectorIds.some((sectorId) =>
                    selectedSectors.includes(sectorId),
                );
            }),
        );
    };

    useEffect(() => {
        let isMounted = true;

        const gameProgressId = window.themes?.user?.current_game_progress;
        const categories = window.categories;
        const categoriesRelatedToSelectedSectors =
            getCategoriesRelatedToSelectedSectors(categories);
        const restURL = window.themeObj?.restURL;
        if (!gameProgressId || !restURL) {
            setIsLoadingScores(false);
            setCategoryScores([]);
            return;
        }

        axios
            .post(`${restURL}/game/get-safety-scores`, {
                game_progress_id: gameProgressId,
                categories: categoriesRelatedToSelectedSectors,
            })
            .then((response) => {
                if (!isMounted) return;
                const scores = response.data?.data?.category_scores;
                if (Array.isArray(scores) && scores.length > 0) {
                    setCategoryScores(scores);
                } else {
                    setCategoryScores([]);
                }
            })
            .catch((error) => {
                if (!isMounted) return;
                console.error("Error fetching safety scores:", error);
                setCategoryScores([]);
            })
            .finally(() => {
                if (isMounted) {
                    setIsLoadingScores(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <LayoutContent>
            <DecorativeLines5 variant="end-page" label="END" />
            <Header visibility={"hidden"} hideActions={true} />
            <div className="endpage">
                <Leaderboard
                    categories={categoryScores}
                    isLoading={isLoadingScores}
                    isScoringEnabled={true}
                />

                <ActionItem
                    teamAction={teamAction}
                    deleteTeamAction={deleteTeamAction}
                    updateTeamAction={updateTeamAction}
                    clearSession={clearSession}
                />
            </div>
        </LayoutContent>
    );
};

export default EndPage;
